import { useEffect } from "react";
import { useCurrencyStore } from "../store/currency";

export default function UmamiAnalytics() {
  const { umamiWebsiteId } = useCurrencyStore();

  useEffect(() => {
    if (!umamiWebsiteId) return;

    // Remove existing umami script if any (to handle dynamic updates)
    const existingScript = document.querySelector('script[src*="cloud.umami.is"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = "https://cloud.umami.is/script.js";
    script.setAttribute("data-website-id", umamiWebsiteId);
    
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [umamiWebsiteId]);

  return null;
}
